import { render, staticRenderFns } from "./UsersPrivilegeEmployeesMovementMedai.vue?vue&type=template&id=b9162d72&scoped=true&"
import script from "./UsersPrivilegeEmployeesMovementMedai.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeesMovementMedai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9162d72",
  null
  
)

export default component.exports